import constants from "../../constants";
import './about.css';

const Mission = () => {
    return <div className="mission-container">
        <h3>{constants.name} exists to {constants.mission}!</h3>
        <div>{constants.missionDetails}</div>
    </div>
};

export default Mission;